import { TApiTask, TApiUsersAccount } from "@timenotes/shared/src/services/api-client/types"
import { useProjectQuery } from "@timenotes/shared/src/services/projects/projects.hooks"
import TimeLogForm from "components/timenotes/timer/time-log-form"
import moment from "moment-timezone"

interface Props {
  date?: moment.Moment
  onSuccess?(): void
  projectId?: string
  task?: TApiTask
  allTimeTotalFilter?: boolean
  usersAccount?: TApiUsersAccount
}

// It wraps the standard TimeLogForm with extra project fetching in case projectId is being provided
export function TimesheetModalTimeLogForm(props: Props) {
  const {
    projectId,
    usersAccount,
    onSuccess,
    date,

    task,
    allTimeTotalFilter
  } = props

  const projectQuery = useProjectQuery({
    projectId: projectId
  })

  const initialValues = {
    project: projectQuery.data?.project,
    task: task,
    usersAccount: usersAccount,
    date: date,
  }

  // Prevent display form if project should be fetched by projectId but is still loading
  // should be handled nicer
  if (projectId && projectQuery.isLoading) {
    return null
  }

  return (
    <TimeLogForm
      // Allow to select date if its total grouping modal, not specific date one
      enableDatePicker={!!allTimeTotalFilter}
      mode="manual"
      date={date}
      initialValues={initialValues}
      enableUsersAccountSelect={true}
      onSuccess={onSuccess}
    />
  )
}